import { createApi } from '@reduxjs/toolkit/query/react';
import { HealthResponse } from '@handover/shared-types';
import { customAuthBaseQuery } from '../customBaseQuery';

export const healthApi = createApi({
  reducerPath: 'healthApi',
  baseQuery: customAuthBaseQuery,
  tagTypes: ['Health'],
  endpoints: builder => ({
    getHealth: builder.query<HealthResponse, void>({
      query: () => '/health',
      providesTags: ['Health'],
      // Keep data fresh for 30 seconds before refetching
      keepUnusedDataFor: 30,
    }),
  }),
});

export const { useGetHealthQuery, useLazyGetHealthQuery } = healthApi;
